import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/pcs_merchant_network_merchant_setting_resource.rb
// (DEV-6370; `versions` added in tio-api#10513).
//
// This is where a pair's ruled `role` and `combined-rate` actually live — they are settings, not
// columns on the pair. The admin pair drawer (#10247) reads them here with `include=versions` to
// show a rate's provenance alongside the ruling batches.
//
// inverse:null on both sides: pcs-merchant-network-merchant.schema.ts declares no reciprocal
// hasMany, and setting-version is a shared history type with no owner-specific back-reference.
const PcsMerchantNetworkMerchantSettingSchema = withDefaults({
  type: 'pcs-merchant-network-merchant-setting',
  fields: [
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsMerchantNetworkMerchant',
      type: 'pcs-merchant-network-merchant',
      options: { async: false, inverse: null },
    },
    {
      kind: 'hasMany',
      name: 'versions',
      type: 'setting-version',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsMerchantNetworkMerchantSettingSchema;
